export default __webpack_public_path__ + "static/media/green-light-logo.b603f913.png";